import React, { useEffect, useState } from "react";
import { Titre } from "../../Fonctions";

export default function Resultats() {
  const [data, setData] = useState({});

  useEffect(() => {
    fetch(`/documents/resultats.json?nocache=${Date.now()}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Erreur de chargement du fichier resultats.json');
        }
        return response.json();
      })
      .then((jsonData) => setData(jsonData))
      .catch((error) => console.error('Erreur lors du fetch:', error));
  }, []);

  if (!data) return <p>Chargement...</p>
// 
const activeResults = data.results
  ? Object.entries(data.results).filter(([, result]) => result.activate)
  : [];

  
  if (! data.activeResults) {
    return (
      <div className="container" id="Resultats">
        <div className="row">
          <div className="col">
            <h1>
              Les premières courses ne sont pas terminées.
            </h1>
          </div>
        </div>
      </div>

    )
  }

  return (
    <div className="container" id="Resultats">
      <div className="row">
        <div className="col">
        {activeResults.map(([key, result]) => (
        <div key={key} style={{ marginBottom: '2rem' }}>
          <Titre libelle={result.title} color="dark" image="cddp"/>
          <p>{result.description}</p>
          <iframe
            src={result.iframe}
            title={result.title}
            style={{ width: '100%', height: '600px', border: '1px solid #ccc' }}
            allowFullScreen
          ></iframe>
        </div>
      ))}
           </div>
      </div>
    </div>
  );
}
